import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { IconPlugConnected } from '@tabler/icons-react';
import { type IWidgetConfigurationSlot } from '../../common/config-slots/IWidgetConfigurationSlot.ts';

/**
 * Card "Impostazioni Servizio", condivisa dai widget basati su servizi esterni
 * (AsyncSelect, AsyncValue).
 */
export const ServiceSettingsSlot: IWidgetConfigurationSlot = {
  key: 'service-settings',
  title: 'Impostazioni Servizio',
  icon: <TbIcon icon={IconPlugConnected} />,
  description:
    'Servizio esterno da cui provengono i dati e mappatura di parametri e risultati.',
  order: 15,
};
